import React from "react";
import { API_URL, getCurrentEnvironment } from "../../constants/api";
import { remove } from "lodash/array";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  apiRequest,
  apiPost,
  apiPut,
  spsApiPost,
  uploadSpsAPiRequest,
  getSpsAPiRequest,
  apiBatchRequest,
  apiRequestAsync
} from "../../utils/api_service";
import {
  Button,
  Box,
  Step,
  Stepper,
  StepLabel,
  Dialog,
  Tooltip,
  IconButton,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import "./requests.less";
import LabelWithSelect from "../common/selectWithLabel/selectWithLabel";
import { InputLabel } from "@material-ui/core";
import LabelWithSwitch from "../common/switchWithLabel/switchWithLabel";
import { ShowToast, toastType } from "../../utils/toast-service";
import { validateInput } from "../../utils/validations";
import { convertIntoDDFormat } from "../../utils/generic";
import uniqBy from "lodash/uniqBy";
import { getArrayObject } from "../../utils/lodash";
import {
  IsTenant,
  removeDuplicates,
  GetUserName,
  IsSectionVisible,
  GetUserConfiguration,
  getToolTipText,
  IsTenantAdmin,
  GetEnableProperty,
  GetPropertyVisibility
} from "../../utils/helper";
import FileAttachments from "../common/sharepoint-upload/file-attachments";
import { getSharepointUrl } from "../common/sharepoint-upload/sharepoint_api";
import { getSPSTokenData } from "../../constants/constants";
import { convertToLocalDate } from "../../utils/date";
import KeyBoardDatePickers from "../common/KeyboardDatePicker/DatePicker";
import KeyBoardDateTimePickers from "../common/KeyboardDateTimePicker/DatePicker";
import MultiSelectDD from "../common/multiSelectDD";
import moment from "moment";
import {
  REQUEST_STATUS,
  SECTIONS,
  Operators,
  setSPSToken,
  REQUEST_TYPE,
  BADGE_TYPE,
  TOOLTIP_LABEL,
  BIOMETRIC_VALUES,
  MINIMUM_SIDE_LEVEL_TO_ENABLE_BIOMETRIC
} from "../../constants/appConstants";
import { isMobile, isTablet } from "react-device-detect";

let uploadFileList = [];

import cx from "classnames";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";
import commonLabels from "../../constants/messageConstants";
import PrintIcon from "@material-ui/icons/Print";
import { BRR_ABRF_Form, PRINT_REQUEST_FORM } from "../../constants/ssrs_api";
import { printForm } from "../../utils/downloading";
import store from "../../store/appStore";
import * as actionType from "../../store/layout/actionTypes";
import ResponseToRequest from "./responseToRequest";
import VirtualizedAutocomplete from "../common/VirtualizedAutocomplete/VirtualizedAutocomplete";
import InfoIcon from "@material-ui/icons/Info";

const stepsGrantAccessWithoutVisitorBadge = [
  "Draft",
  "Awaiting for Signed BRR",
  "Awaiting for ABRF",
  "ABRF Approved",
  "Approved",
  "Denied",
  "Completed",
  "Expired"
];

const stepsOthers = [
  "Draft",
  "Created",
  "In Progress",
  "Approved",
  "Denied",
  "Completed",
  "Expired"
];

const stepsNewGrantAccess = [
  "Draft",
  "In Progress",
  "Engineering Approved",
  "Security Approved",
  "Denied",
  "Completed",
  "Expired"
];

class AddUpdateRequest extends React.Component {
  constructor(props) {
    super(props);
    const { userDetails } = props;
    const userName = GetUserName();
    this.state = {
      userDetails,
      requestId: props.requestId ? props.requestId : 0,
      loginUserMail: GetUserConfiguration().email,
      requestCode: "",
      reqName: userName,
      reqNameList:
        userDetails && userDetails.length
          ? convertIntoDDFormat(
              userDetails.filter(f => f.UserName && f.UserName.length > 0) ||
                [],
              "Email",
              "UserName",
              "PropertyId"
            )
          : [],
      ddSite:
        !IsTenantAdmin() && !IsTenant() ? "" : (userDetails && userDetails.length ? userDetails[0].PropertyId : ""),
      ddRequestType: null,
      ddBadgeTypeId: null,
      textDescription: "",
      responseHistory: "",
      textRequestedFor: "",
      textRequestedForEmail: "",
      textRequestedByDate: null,
      permissionRequestTypeIds: [],
      isOpenResponseToRequest: false,
      requestStatusId: 0,
      createdDate: null,
      requestStatus: "",
      tenantServiceLocations: [],
      selectedServiceLocationIds: [],
      isRequestForInternalUser: true,
      isRequestCreatedByInternalUser: null,

      // New Fields Added on 03/31/2022
      badgeActivateDate: null,
      badgeDeactivateDate: null,
      visitCheckIneDate: null,
      visitCheckOutDate: null,
      vehicleLicensePlate: null,
      prevVisitCheckIneDate: null,
      prevVisitCheckOutDate: null,
      prevVehicleLicensePlate: null,
      ddRelationship: "sponsoring",

      isUploadingFiles: false,
      isAccessRequestSelected: false,
      getToolTip: [],
      textRequestedForCompany: "",
      hasAttachment: false,
      openDialog: false,
      //IPAD
      newGrantAccessProcess: false,
      masterData: props.masterData,
      badgeNumber: "",
      reload: false,

      isResponse: props.requestId > 0 ? false : true,

      isEnablePOI: false,
      multiSiteProperty: [],
      multiSitePropertyName: "",

      recordEntryType: "Browser",
      requirePhysicalKey: false,
      requireBiometrics: false,
      disableBiometricButton: !IsTenantAdmin() && !IsTenant() 
        ? true 
        : (userDetails && userDetails.length)
          ? !(JSON.parse(userDetails[0].RequireBiometrics) && JSON.parse(userDetails[0].RequireBiometricTenantView)) 
          : true,
      hideBiometricButton: !IsTenantAdmin() && !IsTenant() 
        ? true 
        : (userDetails && userDetails.length)
          ? !(JSON.parse(userDetails[0].RequireBiometrics) && JSON.parse(userDetails[0].RequireBiometricTenantView))
          : true,
      notesForPhysicalKey: "",
      isGrantAccess: false,
      grantAccessRequestId: null,
      grantAccessBadgeActivationDate: null,
      grantAccessBadgeDeactivationDate: null,
      grantAccessBadgeNumber: null,
      grantAccessNotesForPhysicalKey: null,
      instructionForPhysicalKey: null,
      isSearchGrantAccess: false
    };
  }

  componentDidMount() {
    const { requestId } = this.state;
    const props = this.props;
    requestId &&
      requestId > 0 &&
      this.getEditRequestData(
        requestId,
        props.requestTypeId == REQUEST_TYPE.ACCESS_REQUEST
          ? props.propertyId
          : null
      );
    requestId == 0 && this.getTenantServiceLocations(0);
    uploadFileList = [];
  }

  /**
   * update component with state and props
   * @param {*} prevProps
   * @param {*} prevState
   */
  componentDidUpdate(prevProps) {
    const props = this.props;
    if (
      props.requestId != prevProps.requestId ||
      props.message !== prevProps.message ||
      props.createdOn !== prevProps.createdOn
    ) {
      props.requestId &&
        props.requestId > 0 &&
        this.getEditRequestData(
          props.requestId,
          props.requestTypeId == REQUEST_TYPE.ACCESS_REQUEST
            ? props.propertyId
            : null
        );
      props.requestId == 0 && this.getTenantServiceLocations(0);
      uploadFileList = [];
    }
  }

  /**
   * update notification panel
   * @param {*} params
   */
  updateNotificationPanel = () => {
    apiRequestAsync({
      url: API_URL.Notification.List,
      key: "pendingNotifications"
    }).then(pendingNotifications => {
      let sorted = [];
      if (pendingNotifications.success) {
        sorted = pendingNotifications?.data?.sort((a, b) => {
          const aDate = new Date(a.createdOn);
          const bDate = new Date(b.createdOn);
          return bDate.getTime() - aDate.getTime();
        });
      }
      store.dispatch({
        type: actionType.GET_NOTIFICATION_DATA,
        payload: sorted
      });
    });
  };

  /**
   * map request data depends upon conditions
   * @param {*} response
   * @param {*} tenantServiceLocations
   * @param {*} getToolTip
   * @param {*} masterData
   * @returns
   */
  mapRequestData = (
    response,
    tenantServiceLocations,
    getToolTip,
    masterData
  ) => {
    const { reload } = this.state;
    this.updateNotificationPanel();
    if (!response.data) return;
    const requestTypeIds = response.data.RequestTypeIds
      ? removeDuplicates(response.data.RequestTypeIds.split(",")).map(i =>
          Number(i)
        )
      : [];
    let selectedSuite = (response.data.Suite?.split(",") || []);

    const multiSiteProperty = (response?.data.PropertyName?.split(",") || []).map(function(item) {
      return item.trim();
    });

    const ddSite = response.data.PropertyId || "";
    let disableBiometricButton= true;
    let requireBiometrics = (response.data.RequireBiometrics?.toString().toLowerCase() === BIOMETRIC_VALUES.BIOMETRIC_REQUIRED);
    let requireBiometricsPropertyCount = 0;

    if(response.data?.RequestTypeId == REQUEST_TYPE.ACCESS_REQUEST) {
      const selectedProperties = (ddSite || '').split(',');
      if (selectedProperties?.length === 0) {
        requireBiometricsPropertyCount = 0;
      } else {
        if(!IsTenantAdmin() && !IsTenant()){
          requireBiometricsPropertyCount = (masterData.data?.propertyMaster || []).filter(x=> { return (selectedProperties || []).includes(x.PropertyId?.toString());}).filter(y=> y.RequireBiometrics === true)?.length;
        } else {
          requireBiometricsPropertyCount = (masterData.data?.propertyMaster || []).filter(x=> { return (selectedProperties || []).includes(x.PropertyId?.toString());}).filter(y=> y.RequireBiometrics === true && y.RequireBiometricTenantView === true)?.length;
        }
      }
    }

    if (response.data.RequestStatusId < REQUEST_STATUS.CREATED) {
      selectedSuite = selectedSuite.map(x=> x.trim());
      const tenantServiceLocationMaster = (tenantServiceLocations?.data || []).filter(f => f.PropertyId.toString() == response.data.PropertyId.toString())
      if (response.data.RequestStatusId < REQUEST_STATUS.CREATED && tenantServiceLocationMaster.length > 0 && tenantServiceLocationMaster.length === selectedSuite?.length) {
        selectedSuite.push("All");
      }
      
      disableBiometricButton = requireBiometricsPropertyCount <= 0;
      requireBiometrics = disableBiometricButton == true ? false : requireBiometrics;
    }

    this.setState(
      {
        hasAttachment: response.data.Attachment,
        requestId: response.data.RequestId,
        requestCode: response.data.RequestCode,
        requestStatusId: response.data.RequestStatusId,
        requestStatus: response.data.RequestStatus,
        requestStatusHistory: response.data.RequestStatusHistory,
        reqName: response.data.RequesterName || "",
        ddSite,
        requestType: removeDuplicates(
          response.data.RequestType?.split(",") || []
        ).map(rt => rt),
        ddRequestType:
          response.data.IsAccessRequestType && requestTypeIds
            ? requestTypeIds[0]
            : null,
        ddBadgeTypeId: response.data.BadgeTypeId || null,
        textDescription: response.data.RequestDescription || "",
        responseHistory: response?.data.ResponseHistory?.split("\\n"),
        textRequestedFor: response.data.RequestedFor,
        textRequestedByDate: response.data.RequestedByDate
          ? moment(response.data.RequestedByDate).format("MM/DD/YYYY")
          : null,
        textRequestedForEmail: response.data.RequestedForEmail,
        permissionRequestTypeIds: requestTypeIds,
        createdDate: response.data.CreatedDate,
        selectedServiceLocationIds: selectedSuite,
        tenantServiceLocations: tenantServiceLocations?.data || [],
        isRequestForInternalUser: response.data.IsRequestForInternalUser,
        isRequestCreatedByInternalUser:
          response.data.TenantUserId != null ? false : null,

        /**
         * ABRF Related fields
         */
        badgeActivateDate: response.data.BadgeActivationDate
          ? moment(response.data.BadgeActivationDate).format("MM/DD/YYYY")
          : null,
        badgeDeactivateDate: response.data.BadgeDeactivationDate
          ? moment(response.data.BadgeDeactivationDate).format("MM/DD/YYYY")
          : null,
        visitCheckIneDate: response.data.ActualCheckInTime
          ? response.data.ActualCheckInTime
          : null,
        visitCheckOutDate: response.data.ActualCheckOutTime
          ? response.data.ActualCheckOutTime
          : null,
        vehicleLicensePlate: response.data.VehicleLicensePlate
          ? response.data.VehicleLicensePlate
          : null,
        prevVisitCheckIneDate: response.data.ActualCheckInTime
          ? response.data.ActualCheckInTime
          : null,
        prevVisitCheckOutDate: response.data.ActualCheckOutTime
          ? response.data.ActualCheckOutTime
          : null,
        prevVehicleLicensePlate: response.data.VehicleLicensePlate
          ? response.data.VehicleLicensePlate
          : null,  
        ddRelationship: response.data.Relationship
          ? response.data.Relationship
          : null,
        /**
         * Condition based state
         */
        isAccessRequestSelected:
          response.data.IsAccessRequestType && requestTypeIds ? true : false,
        textRequestedForCompany: response.data.RequestedForCompany,
        /**
         * tooltip data
         */
        getToolTip: getToolTip?.data,
        newGrantAccessProcess: response.data.NewGrantAccessProcess,
        textStateOnDriverLicenseAbbr:
          response.data.StateOnDriverLicenseAbbreviation,
        textStateOnDriverLicense: response.data.StateOnDriverLicense,
        textDriverLicenseExpiration: response.data.DriverLicenseExpiration,
        textDriverLicense: response.data.DriverLicense,
        textDateOfBirth: response.data.DateOfBirth,
        textPassportCountryOfIssuance: response.data.PassportCountryOfIssuance,
        textPassportExpiration: response.data.PassportExpiration,
        textPassportNumber: response.data.PassportNumber,
        masterData: masterData?.data,
        badgeNumber: response?.data.BadgeNumber,
        reload: !reload,
        isResponse: true,
        isEnablePOI: response?.data.IsEnablePOI,
        multiSiteProperty,
        multiSitePropertyName: response?.data.PropertyName,
        recordEntryType: response.data.RecordEntryType,

        // for grant access request change
        notesForPhysicalKey: response.data.NotesForPhysicalKey,
        requirePhysicalKey: response.data.NotesForPhysicalKey != null && response.data.NotesForPhysicalKey?.length > 0,
        requireBiometrics: requireBiometrics,
        disableBiometricButton: disableBiometricButton,
        hideBiometricButton: requireBiometricsPropertyCount <= 0,

        // remove access request change
        instructionForPhysicalKey: response.data.SpecialInstructionsforPhysicalKey,
        grantAccessBadgeActivationDate: response !== null &&  response.data.GrantAccessBadgeActivationDate != null && response.data.GrantAccessBadgeActivationDate 
                                      ? moment(response.data.GrantAccessBadgeActivationDate).format("MM/DD/YYYY")
                                      : null,
        grantAccessBadgeDeactivationDate: response !== null &&  response.data.GrantAccessBadgeDeactivationDate != null && response.data.GrantAccessBadgeDeactivationDate 
                                      ? moment(response.data.GrantAccessBadgeDeactivationDate).format("MM/DD/YYYY")
                                      : null,
        grantAccessBadgeNumber: response.data.GrantAccessBadgeNumber,
        grantAccessNotesForPhysicalKey: response.data.GrantAccessNotesForPhysicalKey,
        grantAccessRequestId: response.data.GrantAccessRequestId,
        grantAccessRequestCode: response.data.GrantAccessRequestCode

      },
      () => {
        this.forceUpdate();
      }
    );
  };

  /**
   * get edit request data depends based on requestId and propertyId
   * @param {*} requestId
   * @param {*} propertyId
   */
  getEditRequestData = (requestId, propertyId) => {
    apiBatchRequest([
      {
        url: API_URL.request.GetRequestDetailsById,
        params: {
          requestId: requestId,
          currentDateTimeOffset: moment().utcOffset()
        },
        key: "requestDetails"
      },
      {
        url: API_URL.request.GetTenantServiceLocations,
        params: { propertyId: 0 },
        key: "tenantServiceLocations"
      },
      {
        url: API_URL.masterData.GetLabels,
        key: "getToolTip",
        params: { sectionId: SECTIONS.CREATE_REQUEST }
      },
      {
        url: API_URL.masterData.GetRequestMasterData,
        params: {
          propertyId: propertyId,
          showAllStatus: false
        },
        key: "masterData"
      }
    ]).then(
      ({ requestDetails, tenantServiceLocations, getToolTip, masterData }) => {
        this.mapRequestData(
          requestDetails,
          tenantServiceLocations,
          getToolTip,
          masterData
        );
      }
    );
  };

  /**
   * get tooltip
   */
  getTooltip = () => {
    apiRequest({
      url: API_URL.masterData.GetLabels,
      params: { sectionId: SECTIONS.CREATE_REQUEST }
    }).then(({ data: response }) => {
      this.setState({
        getToolTip: response
      });
    });
  };

  /**
   * tenant service location
   * @param {*} propertyId
   */
  getTenantServiceLocations = propertyId => {
    const { getToolTip } = this.state;
    apiRequest({
      url: API_URL.request.GetTenantServiceLocations,
      params: { propertyId: propertyId }
    }).then(({ data: response }) => {
      const { requestId, selectedServiceLocationIds, ddSite } = this.state;
      const selectedServiceLocations = response
        ?.filter(f => f.PropertyId == ddSite)
        .map(function(m) {
          return m.Suite;
        });

      this.setState({
        tenantServiceLocations: response || [],
        selectedServiceLocationIds:
          requestId == 0 &&
          selectedServiceLocations &&
          selectedServiceLocations.length == 1
            ? selectedServiceLocations
            : selectedServiceLocationIds || []
      });
      getToolTip.length == 0 && this.getTooltip();
    });
  };

  /**
   * state change code
   * @param {*} key
   * @param {*} value
   */
  changeState = (key, value) => {
    const {
      userDetails,
      tenantServiceLocations,
      loginUserMail
    } = this.state;
    let selectedServiceLocations = [];
    let disableBiometricButton = this.state.disableBiometricButton;
    if (key === "ddSite") {
      selectedServiceLocations = tenantServiceLocations
        ?.filter(f => f.PropertyId == value)
        .map(function(m) {
          return m.Suite;
        });
      disableBiometricButton = ((userDetails || []).filter(x => x.PropertyId?.toString() === value?.toString() && x.RequireBiometrics === true && x.RequireBiometricTenantView === true) || []).length === 0;
    }
    if (value != undefined && value != null) {
      this.setState({
        disableBiometricButton: disableBiometricButton,
        hideBiometricButton: disableBiometricButton,
        requireBiometrics: disableBiometricButton ? false : this.state.requireBiometrics,
        [key]: value,
        ...(key === "ddSite" && {
          ddSuite: getArrayObject(userDetails, { PropertyId: value })?.Suite,
          selectedServiceLocationIds:
            selectedServiceLocations && selectedServiceLocations.length == 1
              ? selectedServiceLocations
              : []
        }),
        ...(key === "textRequestedForEmail" && {
          ddRelationship:
            (value || "").toLowerCase() === loginUserMail.toLowerCase()
              ? "myself"
              : "sponsoring"
        })
      });
    }
  };

  /**
   * call on multiselect Dropdown
   * @param {*} ids
   */
  onMultiSelectDD = (ids = []) => {
    const {
      selectedServiceLocationIds,
      tenantServiceLocations,
      ddSite,
      ddRequestType
    } = this.state;
    ids = ids == undefined ? [] : ids;
    const index = ids.indexOf(undefined);
    if (index > -1) {
      ids.splice(index);
    }
    const allId = tenantServiceLocations
      .filter(t => t.PropertyId == ddSite)
      .map(function(item) {
        return item.ServiceLocations;
      });
    const allIds = allId != undefined ? allId : [];
    if (ids.indexOf("All") !== -1) {
      const filteredIds = ids.filter(f => f != "All");

      if (
        filteredIds.length == allIds.length ||
        (ids.length > 0 && ids[0] == "All") ||
        (selectedServiceLocationIds.indexOf("All") == -1 &&
          ids.indexOf("All") !== -1)
      ) {
        allIds.push("All");
        this.setState({ selectedServiceLocationIds: allIds, requireBiometrics: this.isBiometricRequired(allIds, ddRequestType) });
      } else {
        this.setState({ selectedServiceLocationIds: filteredIds, requireBiometrics: this.isBiometricRequired(filteredIds, ddRequestType) });
      }
    } else {
      if (selectedServiceLocationIds.indexOf("All") !== -1) {
        this.setState({ selectedServiceLocationIds: [], requireBiometrics: false });
      } else {
        const idsWithoutAll = ids.filter(f => f != "All");
        if (idsWithoutAll.length == allIds.length) {
          allIds.push("All");
          this.setState({ selectedServiceLocationIds: allIds, requireBiometrics: this.isBiometricRequired(allIds, ddRequestType) });
        } else {
          this.setState({ selectedServiceLocationIds: ids, requireBiometrics: this.isBiometricRequired(ids, ddRequestType) });
        }
      }
    }
  };

  /**
   * request change
   * @param {*} key
   * @param {*} value
   */
  changeRequestedFor = (key, value) => {
    const { reqNameList, loginUserMail } = this.state;
    const emailObj = getArrayObject(reqNameList, { value: value });
    this.setState({
      [key]: value,
      textRequestedForEmail: emailObj ? emailObj.id : "",
      ddRelationship:
        ((emailObj ? emailObj.id : "") || "").toLowerCase() ===
        loginUserMail.toLowerCase()
          ? "myself"
          : "sponsoring"
    });
  };

  /**
   * state change
   * @param {*} key
   * @param {*} value
   */
  changeRequestState = (key, value) => {
    this.setState({
      [key]: value,
      ...(key === "ddBadgeTypeId" && {
        badgeDeactivateDate: null
      })
    });
  };

  /**
   * call on request change
   * @param {*} id
   */
  onRequestChange = id => {
    const { permissionRequestTypeIds } = this.state;
    let isBiometricRequired = false;

    if(id == REQUEST_TYPE.ACCESS_REQUEST){
      const isTenantAdmin = IsTenantAdmin();
      const isTenant = IsTenant();
      if(isTenantAdmin || isTenant)
      {
        const { selectedServiceLocationIds } = this.state;
        isBiometricRequired = this.isBiometricRequired(selectedServiceLocationIds, id);
      }
    }
    
    // Access Request Section Set On/Off

    if (
      (id == 8 && permissionRequestTypeIds.indexOf(8) == -1) ||
      (id == 9 && permissionRequestTypeIds.indexOf(9) == -1)
    ) {
      // Enable  Access Section

      this.setState({
        isAccessRequestSelected: true,
        ddRequestType: id,
        newGrantAccessProcess: (id === REQUEST_TYPE.ACCESS_REQUEST),
        requirePhysicalKey: false,
        notesForPhysicalKey: "",
        requireBiometrics: id == REQUEST_TYPE.ACCESS_REQUEST ? isBiometricRequired : false
      });
    } else {
      // Disable Access Section
      this.setState({
        isAccessRequestSelected: false,
        ddRequestType: id,
        requirePhysicalKey: false,
        notesForPhysicalKey: "",
        requireBiometrics: false
      });
    }

    if (permissionRequestTypeIds.indexOf(id) !== -1) {
      remove(permissionRequestTypeIds, n => n == id);
      this.setState({
        permissionRequestTypeIds: permissionRequestTypeIds
      });
    } else {
      this.setState({
        ddBadgeTypeId: null,
        textRequestedFor: "",
        textRequestedForEmail: "",
        permissionRequestTypeIds: [id],
        badgeActivateDate: null,
        badgeDeactivateDate: null,
        visitCheckIneDate: null,
        visitCheckOutDate: null,
        vehicleLicensePlate: null
      });
    }
  };

  /**
   * date deactivation depends upon condition
   * @returns
   */
  decideBadgeDeactivateDate = () => {
    const { badgeActivateDate, ddRequestType } = this.state;
    if (!badgeActivateDate) return null;
    const splitAct = badgeActivateDate.split("/");
    const endFinYear = Number(splitAct[2]) + 1;

    return ddRequestType === 8 ? `03/31/${endFinYear}` : null;
  };

  /* 
  * Check if Biometric is Required or Not based on Request Type, Property and Suite Selection  
  */
  isBiometricRequired = (selectedServiceLocationIds = [], ddRequestType) => {    
    let isBiometricRequired = false;
    const {ddSite, tenantServiceLocations} = this.state;

    if(ddRequestType !== REQUEST_TYPE.ACCESS_REQUEST)
      return false;

    const filteredServiceLocations = tenantServiceLocations?.filter(f => f.PropertyId == ddSite) || [];
    const requireBiometricApplicableForProprty = ((this.state.masterData?.propertyMaster || []).filter(x=> x.PropertyId?.toString() === ddSite?.toString() && x.RequireBiometrics === true && x.RequireBiometricTenantView === true) || []).length > 0;
    if(requireBiometricApplicableForProprty) {
      isBiometricRequired =  (filteredServiceLocations.filter(x=> x.SideLevel >= MINIMUM_SIDE_LEVEL_TO_ENABLE_BIOMETRIC && selectedServiceLocationIds?.find(y=> y === x.ServiceLocations)) || []).length > 0;
    }

    return isBiometricRequired;
  }

  /**
   * call on save button
   * @param {*} isRequestSubmitted
   * @param {*} isRemoveAccessSubmit
   * @returns
   */
  handleSave = (isRequestSubmitted, isRemoveAccessSubmit = false) => {
    const {
      reqName,
      textDescription,
      ddRequestType,
      ddBadgeTypeId,
      textRequestedFor,
      textRequestedForEmail,
      textRequestedByDate,
      badgeActivateDate,
      badgeDeactivateDate,
      ddRelationship,
      requestId,
      permissionRequestTypeIds,
      selectedServiceLocationIds,
      isRequestForInternalUser,
      requestStatus,
      textRequestedForCompany,
      hasAttachment,
      masterData,
      userDetails,
      ddSite,
      recordEntryType,
      tenantServiceLocations,
      requirePhysicalKey,
      notesForPhysicalKey,
      requireBiometrics,
      disableBiometricButton,
      instructionForPhysicalKey,
      grantAccessRequestId,
      isSearchGrantAccess,
      grantAccessBadgeTypeId,
      grantRequestedForCompany,
      getToolTip
    } = this.state;
    let { multiSiteProperty } = this.state;
    const isAbrfEnable =
      ddRequestType === 8 && ddBadgeTypeId && ddBadgeTypeId !== 3;
    const activateDate = new Date(moment(badgeActivateDate)).getTime();
    const deactivateDate = new Date(moment(badgeDeactivateDate)).getTime();
    const requestedDate = new Date(moment(textRequestedByDate)).getTime();
    const localDate = convertToLocalDate(moment());
    const isTenant = IsTenant();
    const currentDate = new Date(
      moment(localDate).format("MM/DD/YYYY")
    ).getTime();
    if (
      badgeDeactivateDate != undefined &&
      badgeDeactivateDate != null &&
      badgeActivateDate != undefined &&
      badgeActivateDate != null
    ) {
      const result = Operators.GreaterThanEqualsTo(
        deactivateDate,
        activateDate
      );
      if (!result.result) {
        ShowToast(
          "Badge Active From can not be greater than Badge Active To.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }
    if (textRequestedByDate != undefined && textRequestedByDate != null) {
      const result2 = Operators.GreaterThanEqualsTo(requestedDate, currentDate);

      if (!result2.result) {
        ShowToast(
          "Requested Completion Date should be greater than or equal to today's date.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }

    if (badgeActivateDate != undefined && badgeActivateDate != null) {
      const result3 = Operators.GreaterThanEqualsTo(activateDate, currentDate);

      if (!result3.result) {
        ShowToast(
          "Badge Active From should be greater than or equal to today's date.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }

    if (
      textRequestedByDate != undefined &&
      textRequestedByDate != null &&
      badgeActivateDate != undefined &&
      badgeActivateDate != null
    ) {
      const result1 = Operators.GreaterThanEqualsTo(
        activateDate,
        requestedDate
      );

      if (!result1.result) {
        ShowToast(
          "Requested Completion Date can not be greater than Badge Active From.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }
    const badgeTypeName = masterData?.badgeTypeMaster?.find(
      b => b.BadgeTypeId == ddBadgeTypeId
    )?.BadgeType;

    let propertyId = ddSite;
    let dataCenterName = userDetails?.find(x => x.PropertyId == ddSite)
    ?.PropertyName;
    const isTenantAdmin = IsTenantAdmin();

    // get selected property when internal loginIn user
    if (!isTenant && !isTenantAdmin) {
      if (multiSiteProperty?.length === 1 && multiSiteProperty.join(",") === "All") {
        const disabledProperty = GetEnableProperty((userDetails || []), SECTIONS.CREATE_REQUEST, "PropertyId");
        multiSiteProperty = disabledProperty.map(x=> x.PropertyName);
      }
     
      multiSiteProperty =  removeDuplicates(multiSiteProperty);
      dataCenterName =  multiSiteProperty.join(", ");
      const selectedDataCenter= userDetails?.filter(x =>  multiSiteProperty.find( mlt => x.PropertyName == mlt));
      const selectedPropertyIds = selectedDataCenter.map(x=> x.PropertyId);
      propertyId   = removeDuplicates(selectedPropertyIds || [])?.join(",");
    }
   
    const index = selectedServiceLocationIds.indexOf("All");
    if (index > -1) {
      selectedServiceLocationIds.splice(index);
    }
    const filteredServiceLocations =
    tenantServiceLocations?.filter(f => f.PropertyId == ddSite) || [];
    const selectedSuiteId = filteredServiceLocations?.filter(x=> selectedServiceLocationIds?.find(y => y === x.ServiceLocations) !== undefined)?.map(x => x.ServiceLocationId) || [];

    const requestBody = {
      requestId: requestId,
      requesterName: reqName,
      requestDescription: textDescription?.trim() /** checked nullable condition */,
      requestedFor: textRequestedFor?.trim() /** checked nullable condition */,
      requestedForEmail: textRequestedForEmail?.trim() /** checked nullable condition */,
      requestedByDate: textRequestedByDate,
      propertyId: propertyId,
      suite:
      selectedSuiteId?.join(",") ||
        "" /** checked nullable condition */,
      isAccessRequestType: (ddRequestType == 8 || ddRequestType == 9) ? true : false,
      requestTypeIds:
        ddRequestType ||
        permissionRequestTypeIds?.toString() /** checked nullable condition */,
      badgeTypeId: isSearchGrantAccess? grantAccessBadgeTypeId : ddBadgeTypeId,
      isRequestSubmitted: isRequestSubmitted,
      environmentName: getCurrentEnvironment().environment,
      isRequestForInternalUser: isRequestForInternalUser,

      badgeActivationDate: ddRequestType === 8 ? badgeActivateDate : null,
      badgeDeactivationDate:
        badgeDeactivateDate && badgeDeactivateDate != null
          ? badgeDeactivateDate
          : null,
      relationship: isAbrfEnable ? ddRelationship : "",
      requestStatus: requestStatus,
      badgeType: badgeTypeName,
      dataCenter: dataCenterName,
      requestedForCompany: isSearchGrantAccess ? grantRequestedForCompany :textRequestedForCompany?.trim(),
      attachment: uploadFileList.length > 0 ? true : hasAttachment,
      isTenant: IsTenant(),
      recordEntryType: recordEntryType,
      notesForPhysicalKey,
      grantAccessRequestId,
      instructionForPhysicalKey,
      requireBiometrics: disableBiometricButton 
                          ? false 
                          : (ddRequestType === REQUEST_TYPE.ACCESS_REQUEST ? requireBiometrics : false)
    };

    const requestValidation = [
      // added validation for data center in case of internal user
      ...(!isTenant && !isTenantAdmin
        ? [
            {
              valueKey: "propertyId",
              type: "text",
              isRequired: true,
              fieldsName: "Data Center" 
            }
          ]
        : []),
      {
        valueKey: "requestDescription",
        type: "text",
        isRequired: true,
        fieldsName: "Request Description"
      },
      {
        valueKey: "requestTypeIds",
        type: "text",
        isRequired: true,
        fieldsName: "Request Type"
      },
      {
        valueKey: "suite",
        type: "text",
        isRequired: isTenant && (ddRequestType == 8 || ddRequestType == 9),
        fieldsName: "Suite"
      },
      ...(ddRequestType === 9 ? [{
        valueKey: "requestedFor",
        type: "alphaNumeric",
        isRequired: !!ddRequestType,
        fieldsName: "Requested For (Name)"
      },
      {
        valueKey: "requestedForEmail",
        type: "email",
        isRequired: !!ddRequestType,
        fieldsName: "Requested For Email"
      },
      {
        valueKey: "badgeTypeId",
        type: "text",
        isRequired: !!ddRequestType,
        fieldsName: "Badge Type"
      }]: []),
      {
        valueKey: "requestedByDate",
        type: "date",
        isRequired: true,
        fieldsName: "Requested Completion Date"
      },
      ...(ddRequestType === 8
        ? [
            {
              valueKey: "requestedFor",
              type: "alphaNumeric",
              isRequired: !!ddRequestType,
              fieldsName: "Requested For (Name)"
            },
            {
              valueKey: "requestedForEmail",
              type: "email",
              isRequired: !!ddRequestType,
              fieldsName: "Requested For Email"
            },
            {
              valueKey: "badgeTypeId",
              type: "text",
              isRequired: !!ddRequestType,
              fieldsName: "Badge Type"
            },
            {
              valueKey: "badgeActivationDate",
              type: "date",
              isRequired: true,
              fieldsName: "Badge Active From"
            },
            {
              valueKey: "badgeDeactivationDate",
              type: "date",
              isRequired: false,
              fieldsName: "Badge Active To"
            },
            {
              valueKey: "notesForPhysicalKey",
              type: "text",
              isRequired: requirePhysicalKey,
              fieldsName: "Notes for Physical Key"
            }
          ]
        : []),
      {
        valueKey: "ddRelationship",
        type: "text",
        isRequired: true,
        fieldsName: "Relationship"
      }
    ];
    if (validateInput(requestBody, requestValidation)) {

      // Validation for Biometrics
    if(isRequestSubmitted === true
      && ddRequestType === REQUEST_TYPE.ACCESS_REQUEST
      && this.state.requestStatusId <= REQUEST_STATUS.DRAFT
      && (isRequestForInternalUser === false || isTenantAdmin || isTenant))
    { 
      if(requireBiometrics && !this.isBiometricRequired(selectedServiceLocationIds, ddRequestType))
      {
        ShowToast(
          "Biometric is NOT required for Suite Level 3 or lower. Please turn OFF 'Require Biometric' button or select Suite Level 4 or higher.",
          toastType.ERROR,
          15000,
          200,
          "",
          true,
          <div className={"col-xs-11 toast-sub-message"}><b><i>Biometric</i></b> is NOT required for <b><i>Suite</i></b> Level 3 or lower. Please turn OFF 'Require Biometric' button or select Suite Level 4 or higher.</div>
        );
        return;
      } else if (!requireBiometrics && this.isBiometricRequired(selectedServiceLocationIds, ddRequestType)){
        ShowToast(
          "Biometric is required for Suite Level 4 or higher. Please turn ON 'Require Biometric' button or select Suite Level 3 or lower.",
          toastType.ERROR,
          15000,
          200,
          "",
          true,
          <div className={"col-xs-11 toast-sub-message"}><b><i>Biometric</i></b> is required for <b><i>Suite</i></b> Level 4 or higher. Please turn ON 'Require Biometric' button or select Suite Level 3 or lower.</div>
        );
        return;
      }
    }

      const isPhysicalKeyRemoveAccessFlow =  masterData?.badgeTypeMaster?.find(
        b => b.BadgeTypeId == ddBadgeTypeId
      )?.IsPhysicalKeyRemoveAccessFlow;

      if (ddRequestType === REQUEST_TYPE.ACCESS_REMOVAL && (isPhysicalKeyRemoveAccessFlow === 1 || isPhysicalKeyRemoveAccessFlow === true) && !isRemoveAccessSubmit) {
        this.searchGrantAccess();
      } else if (requestId) {        
        this.updateRequestApi(requestBody);
      } else {
        this.addRequestApi(requestBody);
      }
    }
  };

  /**
   * call request for api on add button
   * @param {*} params
   */
  addRequestApi = params => {
    const { hasAttachment } = this.state;
    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      params.IsMultisiteRequest = !IsTenant() && !IsTenantAdmin() && params.propertyId?.split(",")?.length > 1;
      apiPost({
        url: API_URL.request.CreateRequest,
        postBody: params
      }).then(({ data: response, success: success }) => {
        const props = this.props;
        this.setState({
          isGrantAccess: false
        });
        if (success) {         
          ShowToast("Request added Successfully", toastType.SUCCESS, 5000, 200);
          if (params.attachment) {
            this.createSPFolder(response.data.requestCode, true);
            this.updateRequestAttachment(response.data.requestId);
          } else props.onSave(true);
        } else {
          props.onSave(false);
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      });
    }
  };

  /**
   * call for api on update request
   * @param {*} params
   */
  updateRequestApi = params => {
    const { hasAttachment, requestId, } = this.state;

    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      params.IsMultisiteRequest = !IsTenant() && !IsTenantAdmin() && params.propertyId?.split(",")?.length > 1;
      apiPut({
        url: API_URL.request.UpdateRequest,
        postBody: params
      }).then(({ data: response, success: success }) => {
        this.setState({
          isGrantAccess: false
        });
        if (response == null || response?.data.Success == 0) {
          ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
          return false;
        }
        const props = this.props;
        if (success) {
          ShowToast(
            "Request updated Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
          //params.attachment &&
          this.createSPFolder(response.data.RequestCode);
          if (hasAttachment) {
            this.updateRequestAttachment(requestId);
          }
          props.onSave(true);
        } else {
          props.onSave(false);
        }
      });
    }
  };

  /**
   * call for api on update request
   */
  updateRequestAttachment = requestId => {
    const fileName = [];
    uploadFileList.forEach(file => {
      fileName.push(file.fileData.name);
    });
    apiPut({
      url:
        API_URL.request.UpdateRequestAttachment +
        "?RequestId=" +
        requestId +
        "&dateTimeOffset=" +
        moment().utcOffset() +
        "&attachment=" +
        fileName.join("|||")
    }).then(({ data: response, success: success }) => {
      if (response == null || response?.data.Success == 0) {
        return false;
      }
      if (success) {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ refreshOnUpdate: true }, () => {
          this.getRequestDetailsById(requestId);
        });
      } else { /* empty */ }
    });
  };

  /**
   * Compare Access InOut section values with existing values to check if there are any changes
   */
  isChangesFoundIntoAccessInOutSection = () => {
    const { visitCheckIneDate, visitCheckOutDate, vehicleLicensePlate, prevVisitCheckIneDate, prevVisitCheckOutDate, prevVehicleLicensePlate } = this.state;
    if(visitCheckIneDate !== prevVisitCheckIneDate)
      return true;
    if(visitCheckOutDate !== prevVisitCheckOutDate)
      return true;
    if(vehicleLicensePlate?.toString().trim() !== prevVehicleLicensePlate?.toString().trim())
      return true;
    return false;  
  }

  /**
   * call Access In-Out Time depends on checks
   * @returns
   */
  updateAccessInOutTime = () => {
    const { visitCheckIneDate, visitCheckOutDate, requestId, vehicleLicensePlate } = this.state;

    if (visitCheckOutDate) {
      const timeDiff = moment(visitCheckIneDate).diff(
        moment(visitCheckOutDate)
      );

      if (timeDiff > 0) {
        ShowToast(
          "Visitor check out time should be greater than check in time.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }
    
    if(this.isChangesFoundIntoAccessInOutSection())
    {
      const requestBody = {
        requestId: requestId,
        actualCheckInTime: visitCheckIneDate
          ? moment(visitCheckIneDate)
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss")
          : null,
        actualCheckOutTime: visitCheckOutDate
          ? moment(visitCheckOutDate)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss")
          : null,
        vehicleLicensePlate: vehicleLicensePlate === null 
          ? null 
          : vehicleLicensePlate?.toString().trim() === ""  
            ? null
            : vehicleLicensePlate?.toString().trim()
      };
      const accessInOutValidation = [
        {
          valueKey: "vehicleLicensePlate",
          type: "alphaNumeric",
          fieldsName: "Vehicle License Plate"
        }
      ];
      
      if (validateInput(requestBody, accessInOutValidation)) {
        apiPut({
          url: API_URL.request.updateReqAccessInOutTime,
          postBody: requestBody
        }).then(({ data: response, success: success }) => {
          if (response == null || response?.data.Success == 0) {
            ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
            return false;
          }
          const props = this.props;

          if (success) {
            ShowToast(
              "Request updated Successfully",
              toastType.SUCCESS,
              5000,
              200
            );
            props.onSave(true);
          } else {
            props.onSave(false);
          }
        });
      }
    } else {
      this.props.onSave(false);
    }
  };

  /*START == Response to Request Dialog*/

  openResponseToRequestDialog = (isOpen = true) => {
    this.setState({ isOpenResponseToRequest: isOpen });
  };

  /**
   * refresh request
   * @param {*} isRefresh
   */
  refreshAddRequest = isRefresh => {
    const props = this.props;
    if (isRefresh) {
      props.refreshRequest();
    }
  };

  /**
   * folder creation for share point
   * @param {*} rCode
   * @param {*} moveToPrevPage
   * @returns
   */
  createSPFolder = (rCode = "", moveToPrevPage = false) => {
    if (!rCode) return;
    if (getSPSTokenData()) {
      getSpsAPiRequest(getSharepointUrl("getInnerFolder", rCode)).then(
        spsDataRes => {
          if (spsDataRes.status === 404) {
            const url = getSharepointUrl("createFolder");
            const postBody = {
              name: rCode,
              folder: {},
              "@microsoft.graph.conflictBehavior": "rename"
            };
            spsApiPost({ url: url, postBody: postBody }).then(data => {
              if (data) {
                this.setState({ openDialog: true });
                this.onFileUpload(rCode, moveToPrevPage);
              }
            });
          } else {
            this.setState({ openDialog: true });
            this.onFileUpload(rCode, moveToPrevPage);
          }
        }
      );
    } else {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
          this.createSPFolder(rCode);
        }
      });
    }
  };

  /**
   * get request details by id
   * @param {*} requestId
   */
  getRequestDetailsById = requestId => {
    apiRequest({
      url: API_URL.request.GetRequestDetailsById,
      params: {
        requestId: requestId,
        currentDateTimeOffset: moment().utcOffset()
      }
    }).then(({ data: res }) => {
      this.setState({
        responseHistory: res?.ResponseHistory?.split("\\n")
      });
    });
  };

  /**
   * file validation
   * @returns
   */
  validateFile = () => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      errorMessage;
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    }
    return isFileValid;
  };

  /**
   * call on upload file
   * @param {*} rCode
   * @param {*} moveToPrevPage
   */
  onFileUpload = (rCode, moveToPrevPage = false) => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    const filesToUpload = uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    } else if (filesToUpload.length > 0) {
      this.setState({
        isUploadingFiles: true,
        hasAttachment: true
      });

      this.UploadFilesToSharepoint(filesToUpload, rCode, moveToPrevPage);
    }
  };

  /**
   * upload file list
   * @param {*} list
   */
  setUploadFilesList = list => {
    uploadFileList = list;
  };

  /**
   * upload attached files
   */
  uploadAttachedFiles = () => {
    const { requestId, requestCode } = this.state;
    const upload = this.validateFile();
    if (upload) {
      if (uploadFileList.length) this.createSPFolder(requestCode);
      this.updateRequestAttachment(requestId);
    }
  };

  /**
   * call on switch button
   * @param {*} value
   * @param {*} key
   */
  onChangeSwitchBtn = (value, key) => {
    this.setState({ [key]: value });
  };

  /**
   * Upload files into sharepoint
   * @param {*} filesToUpload
   * @param {*} rCode
   * @param {*} moveToPrevPage
   */
  UploadFilesToSharepoint = async (filesToUpload, rCode, moveToPrevPage) => {
    let fileUploaded = true;
    const unUploaded = [];
    for (let index = 0; index < filesToUpload.length; index++) {
      const data = await spsApiPost({
        url: getSharepointUrl(
          "uploadFileSession",
          rCode,
          `${rCode}_${filesToUpload[index].fileData.name}`
        ),
        postBody: {
          fileSize: filesToUpload[index].fileData.size,
          item: {
            "@microsoft.graph.conflictBehavior": "replace"
          }
        }
      });
      if (data) {
        const res = await uploadSpsAPiRequest(
          data.data.uploadUrl,
          filesToUpload[index].fileData,
          true
        );
        if (res) {
          /* empty */
        } else {
          fileUploaded = true;
          unUploaded.push(filesToUpload[index].fileData.name);
        }
      }
    }
    const props = this.props;
    if (fileUploaded) {
      ShowToast("File uploaded successfully.", toastType.SUCCESS);
      this.setState({ isUploadingFiles: false, openDialog: false });
      moveToPrevPage && props.onSave(true);
    } else {
      this.setState({ isUploadingFiles: false, openDialog: false });

      ShowToast(
        unUploaded.join(",") + " File not uploaded successfully.",
        toastType.ERROR
      );
    }
  };

  /**
   * check active status
   * @param {*} stepLabel
   * @returns
   */
  checkIfActiveStatus(stepLabel) {
    const { requestStatusHistory } = this.state;
    const statusHistory = requestStatusHistory
      ? requestStatusHistory.split(",")
      : [];
    return statusHistory.indexOf(stepLabel) !== -1;
  }

  /**
   * check expiration
   * @param {*} stepLabel
   * @returns
   */
  checkIfExpiredOrDeniedStatus(stepLabel) {
    return stepLabel === "Expired" || stepLabel === "Denied";
  }

  /**
   * call on print
   */
  handlePrint = (url, isABRFForm = false) => {
    const { requestId, requestType, permissionRequestTypeIds } = this.state;
    const userDetails = GetUserConfiguration();
    const accessGroupId = userDetails?.groups[0].accessGroupId;
    const tenantId = 0;
    let param = null;
    if (isABRFForm) {
      param =
        "RequestId=" +
        requestId +
        "&DateTimeOffset=" +
        moment().utcOffset() +
        "&MaskFlag=True";
    } else {
      param =
        "RequestId=" +
        requestId +
        "&CurrentDateTimeOffset=" +
        moment().utcOffset() +
        "&AccessGroupId=" +
        accessGroupId+
        "&TenantId=" + 
        tenantId;
        url = permissionRequestTypeIds != 8 && permissionRequestTypeIds != 9 ? url.replace("{badgeType}", "Other Access") : url.replace("{badgeType}", requestType?.join(","));

    }

    printForm(`${url}${param}`, "Blank form", "application/pdf");
  };

  /**
   * check request added by tenant to show selected request type selected by tenant
   * @returns
   */
  isTenantAddedRequest = () => {
    const isTenant = IsTenant();
    const { isRequestForInternalUser } = this.state;

    return isTenant === false && isRequestForInternalUser === false;
  };
   
  /**
   * render the single request
   * @returns 
   */
  renderRequest = () => {
      const isPhone = isMobile || isTablet;

      const { userDetails, requestSupportMaster } = this.props;

      const {
          requestId,
          requestCode,
          requestStatusId,
          permissionRequestTypeIds,
          reqName,
          ddSite,
          requestType,
          ddRequestType,
          textRequestedByDate,
          badgeActivateDate,
          createdDate,
          requestStatus,
          tenantServiceLocations,
          selectedServiceLocationIds,
          isRequestForInternalUser,
          isRequestCreatedByInternalUser,
          isUploadingFiles,
          hasAttachment,
          isResponse,
          getToolTip,
          textDescription,
          responseHistory,
          reload,
          multiSiteProperty,
          multiSitePropertyName,
          recordEntryType
        } = this.state;
        
     
      const isTenant = IsTenant();
      const createdDateTime = createdDate
          ? moment(createdDate).format("MM/DD/YYYY hh:mm A")
          : moment(new Date()).format("MM/DD/YYYY hh:mm A");

      const filteredServiceLocations =
        tenantServiceLocations?.filter(f => f.PropertyId == ddSite) || [];
      
      const filteredRequestTypes = isTenant
        ? requestSupportMaster?.filter(
            f => !f.IsAccessRequestType && f.PropertyId == ddSite
          ) || []
        : requestSupportMaster?.filter(
            f =>
              !f.IsAccessRequestType &&
              permissionRequestTypeIds.indexOf(parseInt(f.RequestTypeId, 10)) !=
                -1
          ) || [];

      const filteredRequestTypeForAdmin =
        (!isTenant &&
          requestSupportMaster?.filter(
            f =>
              (!f.IsAccessRequestType && f.RequestTypeId == 2) ||
              (!f.IsAccessRequestType && f.RequestTypeId == 10)
          )) ||
        [];

        let propertyData = uniqBy(
          convertIntoDDFormat(userDetails || [], "PropertyId", "PropertyName"),
          x => x.id
        );
        if (requestStatusId > 1 && (IsTenant() || IsTenantAdmin)) {
          const disabledProperty = GetPropertyVisibility(SECTIONS.CREATE_REQUEST);
          const notSelectedDisabledProperty = disabledProperty.filter(x=> x !== ddSite);
          propertyData = propertyData.filter(dc => (notSelectedDisabledProperty || []).find(x=> x === dc.DataCenterId) === undefined);
               
        } else {
          propertyData = GetEnableProperty((propertyData || []), SECTIONS.CREATE_REQUEST, "id");
        }
        return (<>
          <div className={"row col-xs-12 mb-3"}>
                {requestId > 0 && (
                  <div className={"col-xs-4 col-md-4 col-lg-3"}>
                    <InputLabel
                      className={"small-label"}
                      size={"small"}
                      id={"requestCode"}
                    >
                      {"Request # :"}{" "}
                      {isPhone ? (
                        <>
                          <br />
                          {requestCode}
                        </>
                      ) : (
                        requestCode
                      )}
                    </InputLabel>
                  </div>
                )}
                {requestId > 0 && (
                  <div className={"col-xs-4 col-md-4 col-lg-2"}>
                    <InputLabel
                      className={"small-label"}
                      size={"small"}
                      id={"requestStatus"}
                    >
                      {"Request Status :"}{" "}
                      <span
                        className={
                          requestStatus == "Expired" || requestStatus == "Denied"
                            ? "small-label label-red"
                            : requestStatus == "Completed"
                            ? "small-label label-green"
                            : "small-label"
                        }
                      >
                        {requestStatus}
                      </span>
                    </InputLabel>
                  </div>
                )}
                <div className={"col-xs-4 col-md-4 col-lg-3"}>
                  <InputLabel className={"small-label"} size={"small"} id={"createdOn"}>
                    {"Created On :"}{" "}
                    {isPhone ? (
                      <>
                        <br />
                        {createdDateTime ? createdDateTime : null}
                      </>
                    ) : createdDateTime ? (
                      createdDateTime
                    ) : null}
                  </InputLabel>
                </div>

                <div className={"col-xs-4 col-md-4 col-lg-3"}>
                  <InputLabel className={"small-label"} size={"small"} id={"recordEntryType"}>
                    {"Record Entry Type :"}{" "}
                    {isPhone ? (
                      <>
                        <br />
                        {recordEntryType ? recordEntryType : null}
                      </>
                    ) : recordEntryType ? (
                      recordEntryType
                    ) : null}
                  </InputLabel>
                </div>
          </div>
          <div className={"row col-xs-12 rowList step1-parent no-padding"}>
            <div
              className={
                isPhone
                  ? "col-xs-12 col-md-12 col-lg-7 no-padding"
                  : "col-xs-12 col-md-12 col-lg-7 paddingRightDesk"
              }
            >
              {!isTenant && (
                <div className={"row content row-list"}>
                  <div className={"col-xs-12"}>
                    <LabelWithSwitch
                      key={"isRequestForInternalUser"}
                      labelHeading={"Internal Request"}
                      selectedValue={
                        isRequestCreatedByInternalUser != null
                          ? isRequestCreatedByInternalUser
                          : isRequestForInternalUser
                      }
                      onChange={(k, v) =>
                        this.setState({ isRequestForInternalUser: v })}
                      disabled
                    />
                  </div>
                </div>
              )}

              <div className={"row content"}>
                <div className={"col-xs-6 col-md-6 col-lg-3"}>
                  <LabelWithSelect
                    id={"requesterName"}
                    labelHeading={"Requester Name"}
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.REQUESTOR_NAME
                    )}
                    optionsList={[{ id: 1, value: reqName }]}
                    selectedId={1}
                    disabled
                    className={"box-style"}
                  />
                </div>
                <div className={"col-xs-6 col-md-6 col-lg-4"}>
                  {!IsTenant() && !IsTenantAdmin() && requestStatusId <= REQUEST_STATUS.DRAFT ?                  
                    <VirtualizedAutocomplete
                      defaultAll={false}
                      toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.DATA_CENTER)}
                      isRequired     
                      maxWidth={"100%"}
                      key={"multiSiteProperty"}
                      parentKey={"multiSiteProperty"}
                      reload={reload}
                      isSelectAll
                      header={TOOLTIP_LABEL.DATA_CENTER}
                      optionsList={propertyData}
                      selectedIds={multiSiteProperty || []}   
                      onChange={(val, isNewOption, isInvalid) =>
                        this.onMultiSelect(
                          val,
                          "multiSiteProperty",
                          isNewOption,
                          isInvalid
                        )}
                        limitTags={2}
                    />
                  : !IsTenant() && !IsTenantAdmin() && requestStatusId >= REQUEST_STATUS.CREATED ? (
                      <TextFieldWithToolTip
                          addTitle
                          autoFocus
                          fullWidth
                          id={"multiSitePropertyId"}
                          txtName={"multiSitePropertyName"}
                          keyValue={"multiSitePropertyName"}
                          labelHeading={TOOLTIP_LABEL.DATA_CENTER}
                          value={multiSitePropertyName}
                          disabled
                          toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.DATA_CENTER)}
                      />
                   ) :  <LabelWithSelect
                        id={"dataCenter"}
                        className={"box-style"}
                        labelHeading={"Data Center"}
                        toolTip={getToolTipText(
                          getToolTip,
                          TOOLTIP_LABEL.DATA_CENTER
                        )}
                        optionsList={propertyData}
                        selectedId={ddSite}
                        keyValue={"ddSite"}
                        onChange={this.changeState}
                        disabled={requestStatusId > 1}
                        />}
                </div>
                {isTenant ? (
                  requestStatusId >= REQUEST_STATUS.CREATED ? (
                    <div className={"col-xs-6 col-md-6 col-lg-5"}>
                      <TextFieldWithToolTip
                        addTitle
                        autoFocus
                        fullWidth
                        id={"tenantServiceLocation"}
                        txtName={"tenantServiceLocation"}
                        keyValue={"tenantServiceLocation"}
                        labelHeading={"Suite"}
                        value={selectedServiceLocationIds}
                        disabled
                        toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.SUITE)}
                      />
                    </div>
                  ) : (
                    <div className={"col-xs-6 col-md-6 col-lg-5"}>
                      <MultiSelectDD
                        isRequired={ddRequestType == 8 || ddRequestType == 9}
                        className={"box-style"}
                        header={"Suite"}
                        optionsList={convertIntoDDFormat(
                          filteredServiceLocations || [],
                          "ServiceLocations",
                          "ServiceLocations"
                        )}
                        selectedIds={selectedServiceLocationIds}
                        onChange={this.onMultiSelectDD}
                        disabled={!isTenant || requestStatusId > 1}
                        toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.SUITE)}
                      />
                    </div>
                  )
                ) : !isTenant && selectedServiceLocationIds.length > 0 ? (
                  <div className={"col-xs-6 col-md-6 col-lg-5"}>
                    <TextFieldWithToolTip
                      autoFocus
                      fullWidth
                      id={"tenantServiceLocation"}
                      txtName={"tenantServiceLocation"}
                      keyValue={"tenantServiceLocation"}
                      labelHeading={"Suite"}
                      toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.SUITE)}
                      addTitle
                      value={selectedServiceLocationIds}
                      disabled
                    />
                  </div>
                ) : (
                  <div className={"col-xs-12 col-md-6 col-lg-5 content"}>
                    <KeyBoardDatePickers
                      valueDate={textRequestedByDate}
                      label={"Requested Completion Date"}
                      format={"MM/DD/yyyy"}
                      required
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUESTED_COMPLETION_DATE
                      )}
                      minDate={requestId > 0 ? textRequestedByDate : new Date()}
                      maxDate={badgeActivateDate ? badgeActivateDate : null}
                      handleChange={date =>
                        this.setState({ textRequestedByDate: date })}
                      disabled={requestStatusId > 1}
                    />
                  </div>
                )}
              </div>
              {(isTenant ||
                (!isTenant && selectedServiceLocationIds.length > 0)) && (
                <div className={"row content"}>
                  <div className={"col-xs-12 col-md-6 col-lg-5 content"}>
                    <KeyBoardDatePickers
                      valueDate={textRequestedByDate}
                      label={"Requested Completion Date"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUESTED_COMPLETION_DATE
                      )}
                      format={"MM/DD/yyyy"}
                      required
                      minDate={requestId > 0 ? textRequestedByDate : new Date()}
                      maxDate={badgeActivateDate ? badgeActivateDate : null}
                      handleChange={date =>
                        this.setState({ textRequestedByDate: date })}
                      disabled={!isTenant || requestStatusId > 1}
                    />
                  </div>
                </div>
              )}

              {isPhone ? this.renderAccessView() : <></>}
              <div className={"row content rowList"}>
                <div className={"col-xs-12 no-padding content"}>
                  <div className={isPhone ? "mobileContainer" : "compContainer"}>
                    <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"requestDescriptionLabel"}
                      disabled={requestStatusId > 1}
                      isRequired
                      labelHeading={"Notes"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUEST_DESCRIPTION
                      )}
                    />
                    <TextareaAutosize
                      rowsMin={4}
                      rowsMax={4}
                      aria-label={"Request Description"}
                      placeholder={"Request Description"}
                      value={textDescription}
                      onChange={e =>
                        this.changeState("textDescription", e.target.value)}
                      disabled={requestStatusId > 1}
                    />
                  </div>
                </div>
              </div>
              {requestStatusId > 1 && isResponse ? (
                <div className={"row content rowList"}>
                  <div className={"col-xs-3 no-padding content"}>
                    <div
                      className={isPhone ? "mobileContainer" : "compContainer"}
                    >
                      <TextFieldWithToolTip
                        autoFocus
                        fullWidth
                        id={requestType}
                        txtName={requestType}
                        keyValue={requestType}
                        labelHeading={"Request Type"}
                        value={requestType}
                        disabled
                        toolTip={getToolTipText(
                          getToolTip,
                          TOOLTIP_LABEL.REQUEST_TYPE
                        )}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                isResponse && (
                  <div>
                    <InputLabel
                      disabled={requestStatusId > 1}
                      size={"small"}
                      className={"requestLabel"}
                    >
                      <span>{"Request Type"}</span>
                    </InputLabel>
                    <div className={"row content rowList"}>
                      {isTenant && filteredRequestTypes
                        ? filteredRequestTypes.map(rp => {
                            return (
                              <div className={"col-xs-6 col-md-6 col-lg-4"}>
                                <LabelWithSwitch
                                  className={"box-style"}
                                  key={rp.RequestType}
                                  labelHeading={rp.RequestType}
                                  selectedValue={
                                    permissionRequestTypeIds.indexOf(
                                      rp.RequestTypeId
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  onChange={() =>
                                    this.onRequestChange(rp.RequestTypeId)}
                                  disabled={requestStatusId > 1}
                                  tooltipTitle={rp.Description}
                                />
                              </div>
                            );
                          })
                        : filteredRequestTypeForAdmin &&
                          filteredRequestTypeForAdmin.map(rp => {
                            return (
                              <div className={"col-xs-6 col-md-6 col-lg-4"}>
                                <LabelWithSwitch
                                  className={"box-style"}
                                  key={rp.RequestType}
                                  labelHeading={rp.RequestType}
                                  selectedValue={
                                    permissionRequestTypeIds.indexOf(
                                      rp.RequestTypeId
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  onChange={() =>
                                    this.onRequestChange(rp.RequestTypeId)}
                                  disabled={(requestStatusId > 1)}
                                  tooltipTitle={rp.Description}
                                />
                              </div>
                            );
                          })}
                    </div>
                  </div>
                )
              )}
              <div className={"row content rowList"}>
                <div className={"col-xs-12 no-padding content"}>
                  <div className={isPhone ? "mobileContainer" : "compContainer"}>
                    <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"requestDescriptionLabel"}
                      disabled={requestStatusId > 1}
                      isRequired={false}
                      labelHeading={"Response History"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.RESPONSE_HISTORY
                      )}
                    />
                    <div className={"response-box"}>
                      {responseHistory ? (
                        responseHistory.map(res => (
                          <>
                            <div className={"response"}>{res.split("\\s")[0]}</div>
                            <div className={"response-small"}>
                              {res.split("\\s")[1]}
                            </div>
                            <div>
                              {" "}
                              <br />{" "}
                            </div>
                          </>
                        ))
                      ) : (
                        <div className={"response"}>{"No Response"}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row content rowList"}>
                <div className={"col-xs-12 no-padding"}>
                  <div
                    style={
                      isPhone ? { marginLeft: "2px" } : { marginLeft: "12px" }
                    }
                  >
                    {!isUploadingFiles && (
                      <FileAttachments
                        hasAttachment={hasAttachment}
                        requestCode={requestCode}
                        setUploadFilesList={this.setUploadFilesList}
                        uploadFiles={this.uploadAttachedFiles}
                        showUploadBtn={requestStatusId > 1}
                        downloadPermission
                        reload={reload}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            {isPhone ? <></> : this.renderAccessView()}
          </div>
                </>)
  }

  /**
   * call on onchange of multiselect
   * @param {*} value
   * @param {*} name
   */
  // eslint-disable-next-line no-unused-vars
  onMultiSelect = (value, name) => {
    let requireBiometricsPropertyCount = 0;
    if (value?.length === 0) {
      requireBiometricsPropertyCount = 0;
    } else if (value?.length === 1 && value[0] === 'All') {
      if(!IsTenantAdmin() && !IsTenant()) {
        requireBiometricsPropertyCount = (this.state.masterData?.propertyMaster || []).filter(y=> y.RequireBiometrics === true)?.length;
      } else {
        requireBiometricsPropertyCount = (this.state.masterData?.propertyMaster || []).filter(y=> y.RequireBiometrics === true && y.RequireBiometricTenantView === true)?.length;
      }
    } else {
      if(!IsTenantAdmin() && !IsTenant()) {
        requireBiometricsPropertyCount = (this.state.masterData?.propertyMaster || []).filter(x=> { return (value || []).includes(x.Name);}).filter(y=> y.RequireBiometrics === true)?.length;
      } else {
        requireBiometricsPropertyCount = (this.state.masterData?.propertyMaster || []).filter(x=> { return (value || []).includes(x.Name);}).filter(y=> y.RequireBiometrics === true && y.RequireBiometricTenantView === true)?.length;
      }
    }

    this.setState({
      [name]: Array.isArray(value) ? value : "",
      disableBiometricButton: requireBiometricsPropertyCount <= 0,
      hideBiometricButton: requireBiometricsPropertyCount <= 0,
      requireBiometrics: requireBiometricsPropertyCount <= 0 ? false : this.state.requireBiometrics
    });
  };

   /**
     * This function is used to render Access request Section
     * @returns Jsx Element
   */
  renderAccessView = (multiUi = false) => {
    const isPhone = isMobile || isTablet;
    const { requestSupportMaster } = this.props;
    const isTenant = IsTenant();

    const {
      masterData,
      requestId,
      requestCode,
      requestStatusId,
      permissionRequestTypeIds,
      ddSite,
      ddRequestType,
      ddBadgeTypeId,
      textRequestedFor,
      textRequestedForEmail,
      textRequestedByDate,
      badgeActivateDate,
      badgeDeactivateDate,
      visitCheckIneDate,
      visitCheckOutDate,
      vehicleLicensePlate,
      isAccessRequestSelected,
      textRequestedForCompany,
      textStateOnDriverLicense,
      textStateOnDriverLicenseAbbr,
      textDriverLicenseExpiration,
      textDriverLicense,
      textDateOfBirth,
      textPassportCountryOfIssuance,
      textPassportExpiration,
      textPassportNumber,
      newGrantAccessProcess,
      badgeNumber,
      getToolTip,
      isEnablePOI,
      requirePhysicalKey,
      notesForPhysicalKey,
      requireBiometrics,
      disableBiometricButton,
      hideBiometricButton,
      grantAccessBadgeActivationDate,
      grantAccessBadgeDeactivationDate,
      grantAccessBadgeNumber,
      grantAccessNotesForPhysicalKey,
      instructionForPhysicalKey,
      grantAccessRequestId,
      grantAccessRequestCode
    } = this.state;

      const filteredAccessRequestTypes =
          requestSupportMaster?.filter(function(r) {
            return (
              masterData?.accessRequestTypeMaster?.filter(
                rtm =>
                  r.RequestTypeId == rtm.RequestTypeId &&
                  (!isTenant || r.PropertyId == ddSite)
              ).length > 0
            );
          }) || [];

      /**
       * Requirement is don't show Forgot badge type for Grant Access
      */
      const filteredBadgeTypes = masterData?.badgeTypeMaster?.filter(
          b =>
            (ddRequestType == 9 && b.BadgeTypeId !== 0) ||
            (ddRequestType !== 9 && b.BadgeTypeId !== 9)
        );
      
      const isPhysicalKeyRemoveAccessFlow  = masterData?.badgeTypeMaster?.find( b => b.BadgeTypeId == ddBadgeTypeId)?.IsPhysicalKeyRemoveAccessFlow;

    return (
      <div className={multiUi ? "col-xs-12 col-md-12 col-lg-12 no-padding" : "col-xs-12 col-md-12 col-lg-5 no-padding"}>
        {/* ----------------- Access Request Section------------- */}
        <div>
          {/* Grant Access and Remove Access Toggle Buttons - Sadhana */}
          <div className={"row content rowList"}>
            {filteredAccessRequestTypes &&
              filteredAccessRequestTypes.map(rp => {
                return (
                  <div className={"col-xs-6 no-padding"}>
                    <LabelWithSwitch
                      className={"box-style"}
                      key={rp.RequestType}
                      labelHeading={rp.RequestType}
                      selectedValue={
                        permissionRequestTypeIds.indexOf(rp.RequestTypeId) !==
                        -1
                          ? true
                          : false
                      }
                      onChange={() => this.onRequestChange(rp.RequestTypeId)}
                      disabled={requestStatusId > 1}
                      tooltipTitle={rp.Description}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        {(isPhone && isAccessRequestSelected) || !isPhone ? (
          <>
            <div
              className={cx(
                "row",
                !isAccessRequestSelected && "access-container"
              )}
            >
              <div className={"col-xs-12 access-header"}>
                <InputLabel className={"big-label accessLabel"}>
                  {"ACCESS\r"}
                </InputLabel>
                <br />
              </div>

              <div className={"col-xs-12 access-box no-padding"}>
                <div className={"row"}>
                  <div className={"col-xs-6"}>
                    <TextFieldWithToolTip
                      id={"requestedFor"}
                      txtName={"Requested For"}
                      disabled={
                        requestStatusId > 1 || !isAccessRequestSelected
                      }
                      value={textRequestedFor || ""}
                      keyValue={"textRequestedFor"}
                      onChange={this.changeRequestedFor}
                      isRequired={isAccessRequestSelected}
                      labelHeading={"Requested For (Name)"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUESTED_FOR
                      )}
                    />
                  </div>
                  <div className={"col-xs-6"}>
                    <TextFieldWithToolTip
                      id={"requestedForEmail"}
                      txtName={"RequestedForEmail"}
                      disabled={requestStatusId > 1}
                      value={textRequestedForEmail || ""}
                      keyValue={"textRequestedForEmail"}
                      onChange={this.changeState}
                      isRequired={isAccessRequestSelected}
                      labelHeading={"Requested For Email"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUESTED_FOR_EMAIL
                      )}
                    />
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-xs-6 rowList"}>
                    <LabelWithSelect
                      id={"badgeType"}
                      className={"box-style select-align"}
                      labelHeading={"Badge Type"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.BADGE_TYPE
                      )}
                      optionsList={uniqBy(
                        convertIntoDDFormat(
                          filteredBadgeTypes || [],
                          "BadgeTypeId",
                          "BadgeType"
                        ),
                        x => x.id
                      )}
                      isRequired
                      selectedId={ddBadgeTypeId || ""}
                      keyValue={"ddBadgeTypeId"}
                      onChange={this.changeRequestState}
                      disabled={
                        requestStatusId > 1 || !isAccessRequestSelected
                      }
                    />
                  </div>
                  <div className={"col-xs-6"}>
                    <TextFieldWithToolTip
                      id={"requestedForCompany"}
                      txtName={"RequestedForCompany"}
                      disabled={requestStatusId > 1}
                      value={textRequestedForCompany || ""}
                      keyValue={"textRequestedForCompany"}
                      onChange={this.changeState}
                      isRequired={false}
                      labelHeading={"Requested For Company"}
                      toolTip={getToolTipText(
                        getToolTip,
                        TOOLTIP_LABEL.REQUESTED_FOR_COMPANY
                      )}
                    />
                  </div>
                </div>
                {ddRequestType && ddRequestType === REQUEST_TYPE.ACCESS_REQUEST ? (
                  <div>
                    <div className={"row"}>
                      <div className={"col-xs-12 col-md-12 col-lg-6 "}>
                        <KeyBoardDatePickers
                          valueDate={badgeActivateDate}
                          label={"Badge Active From"}
                          id={"date-picker-dialog1"}
                          toolTip={getToolTipText(
                            getToolTip,
                            TOOLTIP_LABEL.BADGE_ACTIVE_FROM
                          )}
                          format={"MM/DD/yyyy"}
                          required
                          minDate={
                            !requestStatusId || requestStatusId === 1
                              ? textRequestedByDate
                                ? textRequestedByDate
                                : new Date()
                              : ""
                          }
                          handleChange={date =>
                            this.setState({ badgeActivateDate: date, badgeDeactivateDate: date === null ? null : badgeDeactivateDate})
                          }
                          disabled={
                            requestStatusId > 1 || !isAccessRequestSelected
                          }
                        />
                      </div>
                      <div className={"col-xs-12 col-md-12 col-lg-6"}>
                        <KeyBoardDatePickers
                          valueDate={badgeDeactivateDate}
                          label={"Badge Active To"}
                          id={"date-picker-dialog2"}
                          required={false}
                          toolTip={getToolTipText(
                            getToolTip,
                            TOOLTIP_LABEL.BADGE_ACTIVE_TO
                          )}
                          format={"MM/DD/yyyy"}
                          minDate={badgeActivateDate}
                          handleChange={date =>
                            this.setState({ badgeDeactivateDate: date })}
                          disabled={requestStatusId > 1 || !badgeActivateDate}
                        />
                      </div>
                    </div>
                    {requestId > 0 && (
                      <div className={"row"}>
                        <div className={"col-xs-6"}>
                          <TextFieldWithToolTip
                            id={"badgeNumber"}
                            txtName={"badgeNumber"}
                            disabled
                            value={badgeNumber || ""}
                            keyValue={"textBadgeNumber"}
                            labelHeading={"Badge Number"}
                            toolTip={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.BADGE_NUMBER
                            )}
                          />
                        </div>
                      </div>
                    )}
                    
                    <div className={"row"}>
                      {hideBiometricButton === false && <div className={"col-xs-12 col-md-12 col-lg-6 "}>
                          <LabelWithSwitch
                            key={"requireBiometrics"}
                            labelHeading={"Require Biometric"}
                            selectedValue={requireBiometrics}
                            className={"box-style"}
                            onChange={(k, v) => this.setState({ requireBiometrics: v })}
                            disabled={requestStatusId > 1 || disableBiometricButton}
                            tooltipTitle={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.BIOMETRICS
                            )}
                          />
                      </div>
                      }
                      <div className={"col-xs-12 col-md-12 col-lg-6 "}>
                          <LabelWithSwitch
                            key={"requirePhysicalKey"}
                            labelHeading={"Require Physical Key"}
                            selectedValue={requirePhysicalKey}
                            className={"box-style"}
                            onChange={(k, v) =>
                            this.setState({ requirePhysicalKey: v, notesForPhysicalKey: "" })}
                            disabled={requestStatusId > 1}
                            tooltipTitle={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.PHYSICAL_KEY
                            )}
                          />
                      </div>
                    </div>
                    {requirePhysicalKey ? 
                    <div className={"row"}>
                      <div className={"col-xs-12 col-md-12 col-lg-12 "}>
                      <div className={"col-xs-12 no-padding content note-for-physical-key"}>
                        <div className={isPhone ? "mobileContainer" : "compContainer"}>
                          <InputLabelWithToolTip
                            className={"compLabel"}
                            id={"notesForPhysicalKey"}
                            disabled={requestStatusId > 1}
                            isRequired
                            labelHeading={"Notes for Physical Key"}
                          />
                          <TextareaAutosize
                            rowsMin={4}
                            rowsMax={4}
                            aria-label={"Notes for Physical Key"}
                            value={notesForPhysicalKey}
                            onChange={e =>
                              this.changeState("notesForPhysicalKey", e.target.value)}
                            disabled={requestStatusId > 1}
                          />
                        </div>
                      </div>
                      </div>
                    </div> : ""}
                  </div>                 
                ) : (
                  ""
                )}
                 {ddRequestType && ddRequestType === REQUEST_TYPE.ACCESS_REMOVAL && grantAccessRequestId > 0 && requestId > 0 &&  (isPhysicalKeyRemoveAccessFlow === 1 || isPhysicalKeyRemoveAccessFlow === true)
                    ?
                    <>
                      <div className={"row"}>
                        <div className={"col-xs-6"}>
                          <TextFieldWithToolTip
                            id={"grantAccessBadgeActivationDate"}
                            txtName={"GrantAccessBadgeActivationDate"}
                            disabled
                            value={grantAccessBadgeActivationDate || ""}
                            keyValue={"grantAccessBadgeActivationDate"}
                            labelHeading={"Badge Active From"}
                            toolTip={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.BADGE_ACTIVE_FROM
                            )}
                            isRequired
                          />
                        </div>
                        <div className={"col-xs-6"}>
                          <TextFieldWithToolTip
                            id={"grantAccessBadgeDeactivationDate"}
                            txtName={"grantAccessBadgeDeactivationDate"}
                            disabled
                            value={grantAccessBadgeDeactivationDate || ""}
                            keyValue={"grantAccessBadgeDeactivationDate"}
                            labelHeading={"Badge Active To"}
                            toolTip={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.BADGE_ACTIVE_TO
                            )}
                          />
                        </div>
                      </div>
                      <div className={"row special-instruction-margin-bottom"}>
                        <div className={"col-xs-6"}>
                          <TextFieldWithToolTip
                            id={"grantAccessBadgeNumber"}
                            txtName={"GrantAccessBadgeNumber"}
                            disabled
                            value={grantAccessBadgeNumber || ""}
                            keyValue={"grantAccessBadgeNumber"}
                            labelHeading={"Badge #"}
                            toolTip={getToolTipText(
                              getToolTip,
                              TOOLTIP_LABEL.BADGE_NUMBER
                            )}
                          />
                        </div>

                        <div className={"col-xs-6"}>
                          <TextFieldWithToolTip
                            id={"grantAccessRequestCode"}
                            txtName={"GrantAccessRequestCode"}
                            disabled
                            value={grantAccessRequestCode || ""}
                            keyValue={"grantAccessRequestCode"}
                            labelHeading={"Grant Access Request #"}
                          />
                        </div>
                      </div>
                      <div className={"row"}>
                        <div className={"col-xs-12 note-instruction-for-physical-key note-for-physical-key special-instruction-margin-bottom "}>
                         
                          <InputLabelWithToolTip
                            className={"compLabel"}
                            id={"grantAccessNotesForPhysicalKey"}
                            disabled
                            labelHeading={"Notes for Physical Key"}
                          />
                          <TextareaAutosize
                            rowsMin={4}
                            rowsMax={4}
                            aria-label={"Notes for Physical Key"}
                            value={grantAccessNotesForPhysicalKey}
                            disabled
                          />
                        </div>
                      </div>                    
                    </>
                    : null}

                  {
                      ddRequestType && ddRequestType === REQUEST_TYPE.ACCESS_REMOVAL ?
                        <div className={(grantAccessRequestId === null  || grantAccessRequestId <= 0 ) ? "row special-instruction-margin-top special-instruction-margin-bottom": "row special-instruction-margin-bottom"}>
                          <div className={"col-xs-12 note-instruction-for-physical-key"}>
                            <InputLabelWithToolTip
                                  className={"compLabel"}
                                  id={"instructionForPhysicalKey"}
                                  labelHeading={"Special instructions related to Physical Key (if any)"}
                                  disabled={requestStatusId > 1}                              
                                  toolTip={getToolTipText(
                                    getToolTip,
                                    TOOLTIP_LABEL.NOTE_FOR_SPECIAL_PHYSICAL_KEY
                                  )}
                            />
                            <TextareaAutosize
                              rowsMin={4}
                              rowsMax={4}
                              aria-label={"Special instructions related to Physical Key (if any)"}
                              value={instructionForPhysicalKey}
                              disabled={requestStatusId > 1}
                              onChange={e =>
                                this.changeState("instructionForPhysicalKey", e.target.value)}
                            />
                          </div>
                        </div>
                      : ""

                  }

                {(requestStatusId === REQUEST_STATUS.APPROVED ||
                  requestStatusId === REQUEST_STATUS.COMPLETED ||
                  requestStatusId === REQUEST_STATUS.ENGINEERING_APPROVED ||
                  requestStatusId === REQUEST_STATUS.SECURITY_APPROVED) &&
                ddRequestType &&
                ddRequestType === REQUEST_TYPE.ACCESS_REQUEST ? (
                  <>
                  <div className={"row"}>
                    <div className={"col-xs-12 col-md-12 col-lg-6 "}>
                      <KeyBoardDateTimePickers
                        valueDate={visitCheckIneDate}
                        label={"Visitor Check In"}
                        toolTip={getToolTipText(
                          getToolTip,
                          TOOLTIP_LABEL.VISITOR_CHECK_IN
                        )}
                        format={"MM/DD/YYYY hh:mm A"}
                        minDate={badgeActivateDate}
                        maxDate={badgeDeactivateDate}
                        handleChange={date =>
                          this.setState({ visitCheckIneDate: date, visitCheckOutDate: date === null? null : visitCheckOutDate})}
                        disabled={isTenant}
                      />
                    </div>
                    <div className={"col-xs-12 col-md-12 col-lg-6"}>
                      <KeyBoardDateTimePickers
                        valueDate={visitCheckOutDate}
                        label={"Visitor Check Out"}
                        toolTip={getToolTipText(
                          getToolTip,
                          TOOLTIP_LABEL.VISITOR_CHECK_OUT
                        )}
                        format={"MM/DD/YYYY hh:mm A"}
                        required={false}
                        minDate={
                          visitCheckIneDate
                            ? visitCheckIneDate
                            : textRequestedByDate
                        }
                        handleChange={date =>
                          this.setState({ visitCheckOutDate: date })}
                        disabled={!visitCheckIneDate || isTenant}
                      />
                    </div>
                  </div>
                  <div className={"row"}>
                    <div  className={"col-xs-12 col-md-12 col-lg-6 "}> 
                      <TextFieldWithToolTip
                        id={"VehicleLicensePlate"}
                        txtName={"VehicleLicensePlate"}
                        labelHeading={"Vehicle License Plate"}
                        value={vehicleLicensePlate || ""}
                        onChange={e => { if (e.target.value.length <= 50) {
                              this.setState({ vehicleLicensePlate: e.target.value })
                            }
                          }
                        }
                        disabled={isTenant}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == TOOLTIP_LABEL.VEHICLE_LICENSE_PLATE
                          )?.Tooltip
                        }
                      />
                    </div>
                    <div className={"col-xs-12 center-xs content"}>
                        <Button
                          autoFocus
                          onClick={this.updateAccessInOutTime}
                          variant={"contained"}
                          disabled={isTenant}
                        >
                          {"Update\r"}
                        </Button>
                      </div>
                  </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

           
            {ddRequestType === 8 &&
            requestCode &&
            newGrantAccessProcess &&
            textDriverLicense  && 
            isEnablePOI ? (
              <div className={"row mt-10"}>
                <div className={"col-xs-12 access-header"}>
                  <InputLabel className={"big-label accessLabel"}>
                    {"Proof of Identity\r"}
                  </InputLabel>
                  <br />
                </div>

                <div className={"col-xs-12 access-box"}>
                  <div>
                    <div className={"row"}>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"DOB"}
                          txtName={"DOB"}
                          disabled
                          value={
                            textDateOfBirth != null
                              ? moment(textDateOfBirth, "MM/YYYY").format(
                                  "MM/YYYY"
                                )
                              : ""
                          }
                          keyValue={"textDateOfBirth"}
                          labelHeading={"DOB"}
                        />
                      </div>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"DL"}
                          txtName={"DL#"}
                          disabled
                          value={textDriverLicense || ""}
                          keyValue={"textDriverLicense"}
                          labelHeading={"DL #"}
                        />
                      </div>
                    </div>
                    <div className={"row"}>
                      <div className={"col-xs-6 rowList"}>
                        <TextFieldWithToolTip
                          id={"Driver"}
                          txtName={"DriverState"}
                          disabled
                          value={
                            textStateOnDriverLicenseAbbr != null &&
                            textStateOnDriverLicense
                              ? textStateOnDriverLicenseAbbr +
                                "-" +
                                textStateOnDriverLicense
                              : ""
                          }
                          keyValue={"textStateOnDriverLicense"}
                          labelHeading={"Driver's State"}
                        />
                      </div>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"ExpirationDate"}
                          txtName={"DriverExpirationDate"}
                          disabled
                          value={
                            textDriverLicenseExpiration != null
                              ? moment(textDriverLicenseExpiration).format(
                                  "MM/DD/YYYY"
                                )
                              : ""
                          }
                          keyValue={"textDriverLicenseExpiration"}
                          labelHeading={"Expiration Date"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : ddRequestType === 8 &&
              requestCode &&
              newGrantAccessProcess &&
              textPassportNumber ? (
              <div className={"row mt-10"}>
                <div className={"col-xs-12 access-header"}>
                  <InputLabel className={"big-label accessLabel"}>
                    {"Proof of Identity\r"}
                  </InputLabel>
                  <br />
                </div>

                <div className={"col-xs-12 access-box"}>
                  <div>
                    <div className={"row"}>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"DOB"}
                          txtName={"DOB"}
                          disabled
                          value={
                            textDateOfBirth != null
                              ? moment(textDateOfBirth, "MM/YYYY").format(
                                  "MM/YYYY"
                                )
                              : ""
                          }
                          keyValue={"textDateOfBirth"}
                          labelHeading={"DOB"}
                        />
                      </div>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"Passport"}
                          txtName={"Passport#"}
                          disabled
                          value={textPassportNumber || ""}
                          keyValue={"textPassportNumber"}
                          labelHeading={"Passport #"}
                        />
                      </div>
                    </div>
                    <div className={"row"}>
                      <div className={"col-xs-6 rowList"}>
                        <TextFieldWithToolTip
                          id={"CountryOfIssuance"}
                          txtName={"CountryOfIssuance"}
                          disabled
                          value={textPassportCountryOfIssuance || ""}
                          keyValue={"textPassportCountryOfIssuance"}
                          labelHeading={"Country Of Issuance"}
                        />
                      </div>
                      <div className={"col-xs-6"}>
                        <TextFieldWithToolTip
                          id={"PassportExpirationDate"}
                          txtName={"PassportExpirationDate"}
                          disabled
                          value={
                            textPassportExpiration != null
                              ? moment(textPassportExpiration).format(
                                  "MM/DD/YYYY"
                                )
                              : ""
                          }
                          keyValue={"textPassportExpiration"}
                          labelHeading={"Expiration Date"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    );
  };

  /**
   * search completed grant request to get physical key 
   */

  searchGrantAccess = () => {
    const { 
      textRequestedFor,
      textRequestedForEmail
      } = this.state;
    
    apiRequest({
      url: API_URL.request.GetPhysicalKeyGrantRequest + "?requestedFor=" + textRequestedFor + "&requestedForEmail=" + textRequestedForEmail,
    }).then(({ data: response }) => {
        this.setState({
        grantAccessBadgeActivationDate: response !== null && response.badgeActivationDate       
                          ? moment( response.badgeActivationDate).format("MM/DD/YYYY")
                          : null,
        grantAccessBadgeDeactivationDate: response !== null &&  response.badgeDeactivationDate
                          ? moment( response.badgeDeactivationDate).format("MM/DD/YYYY")
                          : null,
        badgeNumber: response !== null ? response.badgeNumber: null,
        grantAccessBadgeTypeId:response !== null ? response.badgeTypeId : null,
        grantAccessRequestId: response !== null ? response.requestId: null,
        notesForPhysicalKey: response !== null ? response.notesForPhysicalKey : "",
        grantRequestedForCompany: response !== null ? response.requestedForCompany : "",
        isGrantAccess: true,
        isSearchGrantAccess: response !== null,
        grantAccessRequestCode: response !== null ? response.requestCode: null,
        grantAccessCreatedDate: response !== null && response.createdDate
                                ? moment( response.createdDate).format("MM/DD/YYYY")
                                : null
            
      });
    });
  }

  /**
   * return the print button according to request type
   * @returns 
 */
  renderPrintButton = () => {

    const {
        requestId,
        ddRequestType,       
        newGrantAccessProcess,
        getToolTip,
        isEnablePOI
      } = this.state;
    
      return (<>
              {requestId > 0 && (
                <Tooltip
                  title={getToolTipText(getToolTip, TOOLTIP_LABEL.PRINT_REQUEST)}
                >
                  <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                    <PrintIcon
                      onClick={() => {
                        this.handlePrint(PRINT_REQUEST_FORM);
                      }}
                      style={{ fontSize: "2rem" }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {IsSectionVisible(SECTIONS.REQUEST, SECTIONS.PRINT_BRR_ABRF_FORM) &&
                newGrantAccessProcess &&
                ddRequestType === REQUEST_TYPE.ACCESS_REQUEST &&
                requestId > 0 && (
                  <Tooltip
                    title={getToolTipText(getToolTip, (isEnablePOI ?  TOOLTIP_LABEL.PRINT : TOOLTIP_LABEL.PRINT_BRR))}
                  >
                    <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                      <PrintIcon
                        onClick={() => {
                          this.handlePrint(BRR_ABRF_Form, true);
                        }}
                        style={{ fontSize: "2rem", fill: "#ee6767" }}
                      />
                    </IconButton>
                  </Tooltip>
              )}
              </>)
  }
 
  /*END == Response to Request Dialog*/
  render() {

    const respondToRequestVisible = IsSectionVisible(
      SECTIONS.REQUEST,
      SECTIONS.RESPOND_TO_REQUEST
    );

    const props = this.props;

  
    const {
      masterData,
      requestId,
      requestCode,
      requestStatusId,
      permissionRequestTypeIds,
      requestType,
      ddRequestType,
      ddBadgeTypeId,
      isOpenResponseToRequest,
      selectedServiceLocationIds,
      requestStatusHistory,
      newGrantAccessProcess,
      getToolTip,
      openDialog,
      isGrantAccess,
      grantAccessCreatedDate,
      grantAccessRequestCode,
      isSearchGrantAccess
    } = this.state;


    const requestData = {
      requestId: requestId,
      requestCode: requestCode,
      requestType: requestType,
      requestTypeId: permissionRequestTypeIds ? permissionRequestTypeIds[0] : 0,
      badgeTypeId: ddBadgeTypeId,
      newGrantAccessProcess: newGrantAccessProcess
    };

    const index = selectedServiceLocationIds.indexOf(undefined);
    if (index > -1) {
      selectedServiceLocationIds.splice(index);
    }

    const indexForNull = selectedServiceLocationIds.indexOf("");
    if (indexForNull > -1) selectedServiceLocationIds.splice(indexForNull);
    


    let steps = [];
    const isOldGrantAccessRecord =
      requestStatusHistory?.indexOf("Awaiting for Signed BRR") != -1 ||
      requestStatusHistory?.indexOf("ABRF Approved") != -1 ||
      requestStatusHistory?.indexOf("Awaiting for ABRF") != -1 ||
      (requestStatusHistory?.indexOf("Created") != -1 &&
        ddBadgeTypeId == BADGE_TYPE.Visitor_Badge &&
        (requestStatusHistory?.indexOf("Expired") != -1 ||
          requestStatusHistory?.indexOf("Completed") != -1 ||
          requestStatusHistory?.indexOf("Denied") != -1)) ||
      false;
    if (
      newGrantAccessProcess &&
      ddRequestType === REQUEST_TYPE.ACCESS_REQUEST &&
      !isOldGrantAccessRecord
    ) {
      steps = stepsNewGrantAccess;
    } else {
      steps =
        ddRequestType == REQUEST_TYPE.ACCESS_REQUEST &&
        isOldGrantAccessRecord
          ? stepsGrantAccessWithoutVisitorBadge
          : stepsOthers;
    }
    const isDenied = requestStatusHistory?.indexOf("Denied") != -1 || false;
    const isExpired = requestStatusHistory?.indexOf("Expired") != -1 || false;
    const isCompleted =
      requestStatusHistory?.indexOf("Completed") != -1 || false;
    if (isDenied) {
      steps = steps.filter(f => f != "Expired" && f != "Completed");
    } else if (isExpired) {
      steps = steps.filter(f => f != "Denied" && f != "Completed");
    } else if (isCompleted) {
      steps = steps.filter(f => f != "Denied" && f != "Expired");
    }
    const isPhone = isMobile || isTablet;
    (requestStatusId <= 1 || respondToRequestVisible) &&
      localStorage.setItem("IsInEditMode", 1);

    const grantRecordFound = {__html:( getToolTipText(
      getToolTip,
      TOOLTIP_LABEL.GRANT_ACCESS_FOUND
    ).replace("{{RequestCode}}", grantAccessRequestCode).replace("{{CreatedDate}}", grantAccessCreatedDate))}

    const grantRecordNotFound = {__html:(getToolTipText(
      getToolTip,
      TOOLTIP_LABEL.GRANT_ACCESS_NOT_FOUND
      ))};
    
    return (
      <div
        className={
          isPhone ? "row addUpdateReqMobilePage" : "row addUpdateReqPage"
        }
      >

        {isGrantAccess &&
          
          <div>
          <Dialog
            className={"head-btn-icon remove-grant-access-popup"}
            open={isGrantAccess}
            fullWidth
            maxWidth={"xs"}
          >

            <DialogContent>
              <div className={"row"}>
                <div className={"col-xs-12 no-padding-left info-filled"}>
                  <IconButton
                      id={"iconBtn"}
                      size={"medium"}
                      className={"tooltip-iconSize"}
                  >
                      <InfoIcon fontSize={"inherit"} />
                  </IconButton>
                </div>
                <div className={"col-xs-12 no-padding-left"}>               
                  { isSearchGrantAccess ?
                        <div dangerouslySetInnerHTML={grantRecordFound} />
                    :
                    <div dangerouslySetInnerHTML={grantRecordNotFound} />}
                    
                </div>
              </div>
            </DialogContent>
            <DialogActions style={{ paddingRight: "5px" }}>     
              <Button
                  style={{ marginRight: "3px" }}
                  autoFocus
                  variant={"contained"}
                  className={"grant-request-not-fond-btn"}
                  onClick={() => this.handleSave(true, true)}
              >
                {"Yes\r"}
              </Button>       
              <Button
                autoFocus
                variant={"contained"}
                className={"grant-request-not-fond-btn no-button"}
                onClick={() => {
                  this.setState({
                     isGrantAccess: false
                  });
                }}
              >
                {"No\r"}
              </Button>             
            </DialogActions>
          </Dialog>
          </div>}




        {isPhone ? <></> : <div className={"col-xs-1"} />}
        <div className={isPhone ? "col-xs-12 no-padding" : "col-xs-10"}>
          {requestId > 0 && (
            <Box sx={{ width: "100%" }}>
              <Stepper alternativeLabel={isPhone}>
                {steps.map(label => (
                  <Step
                    className={
                      this.checkIfExpiredOrDeniedStatus(label) ? "text-red" : ""
                    }
                    key={label}
                    active={this.checkIfActiveStatus(label)}
                    completed={this.checkIfActiveStatus(label)}
                    id={"Status_" + label}
                  >
                    <StepLabel id={"Status_Label_" + label} icon={"X"}>
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          )}
        </div>
        {isPhone ? <> {this.renderPrintButton()}</> : 
        <div className={"col-xs-1 end-xs"}>
          {this.renderPrintButton()}
        </div>}
        {this.renderRequest()}
        <div>
          {isOpenResponseToRequest ? (
            <ResponseToRequest
              getToolTip={getToolTip}
              isOpen={isOpenResponseToRequest}
              onClose={this.openResponseToRequestDialog}
              refreshRequest={this.refreshAddRequest}
              requestData={requestData}
              requestStatusId={requestStatusId}
              requestStatusMaster={masterData.requestStatusMaster || []}
            />
          ) : (
            ""
          )}
        </div>
        <div className={"col-xs-12 col-md-12 col-lg-12 end-lg no-padding req_actions"}>
          <Button
            autoFocus
            onClick={() => props.refreshRequest(true)}
            variant={"contained"}
          >
            {"Cancel"}
          </Button>

          {respondToRequestVisible &&
          requestId > 0 &&
          requestStatusId != REQUEST_STATUS.DRAFT ? (
            <>
              <Button
                onClick={this.openResponseToRequestDialog}
                variant={"contained"}
                color={"primary"}
              >
                {"Respond To Request"}
              </Button>
            </>
          ) : (
            <>
              {requestStatusId <= 1 && (
                <>
                  {ddRequestType !== REQUEST_TYPE.ACCESS_REMOVAL &&
                    <Button
                      autoFocus
                      onClick={() => this.handleSave(false)}
                      variant={"contained"}
                    >
                      {"Save As Draft"}
                    </Button>}
                  <Button
                    autoFocus
                    onClick={() => this.handleSave(true)}
                    variant={"contained"}
                  >
                    {"Submit"}
                  </Button>
                </>
              )}
            </>
          )}
        </div>
        {openDialog && (
          <Dialog
            style={{ marginTop: "60px" }}
            open={openDialog}
            aria-labelledby={"responsive-dialog-title"}
            maxWidth={"lg"}
          >
            <div style={{ padding: "4px 13px", fontSize: "larger" }}>
              {"Uploading file...\r"}
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}
export default AddUpdateRequest;
